<template>
  <div class="staticChart">
    <table>
        <tr>
            <th>REFINEMENTS:</th>
            <th>NEAR</th>
            <th>DISTANCE</th>
        </tr>
        <tr v-if="lowADDRow" class="bordered"> 
            <td><strong>TWO LOW ADDS</strong></td>
            <td>Switch non-dominant eye to high ADD</td>
            <td>Switch dominant eye to single-vision spherical lens</td>
        </tr>
        <tr v-if="highADDRow" class="bordered">
            <td><strong>TWO HIGH ADDS</strong></td>
            <td>Add +.25 to non-dominant eye</td>
            <td>Switch dominant eye to low ADD</td>
        </tr>
    </table> 
    <br/>    
  </div>
</template>

<script>
export default {
    
  name: 'StaticChart',
  props: {
   highADDRow: {
      type:Boolean,
      default: false
   },
   lowADDRow: {
      type:Boolean,
      default: true
   }
  },
  methods: {},
  watch: {
   highADDRow: function(val) {
      console.log(val +' THIS IS THE VALUE')
   }
  },
  data() {
    return {}
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


 
 .bordered {
    border-top: 1px solid #000;
    border-left: 1px solid #000;
    border-right: 1px solid #000;
 }
 .bordered:nth-of-type(odd) {
    border-bottom: 1px solid #000
 }
 .bordered td {
    border-right: 1px solid #000;
 }
 .bordered .col:last-of-type {
    border-right: none;
 }
 table {
    width: 100%;
 }
 table th {
    width: 33%;
 }
 table td {
    padding: 20px;
    text-align: center;
 }
 table th:not(:first-of-type) {
    text-align: center;
 }
</style>
